import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { OpportunityLevelViewModel } from './opportunity-level.model';

export class OpportunityLevelConfiguration extends ReportSectionConfigurationBase {
  typeName = 'OpportunityLevelConfiguration';
  nodataLocalizationKeyName = 'opportunityLevel';
  readonly reportSection = ReportSection.OpportunityLevel;
  readonly name = 'opportunityLevel';
  readonly displayName = 'Opportunity Level';
  readonly applicableReportTypes = [ReportType.PeerOwnershipReport];
  readonly reportViewModelSections = [ReportViewModelSection.PeerOwnershipReport_OpportunityLevel];
  readonly minSize = 1;
  readonly maxSize = 2;
  readonly defaultSize = 1;
  readonly availableDataSections: ReportSectionDataSection[] = [];
}

export interface OpportunityLevelDataBag {
  [ReportViewModelSection.PeerOwnershipReport_OpportunityLevel]: OpportunityLevelViewModel;
}
